import React from 'react';
import privacyPolicyPDF from 'assets/Future_Skill_AB_Privacy_Policy.pdf';
export const emailPlaceholder = { de: 'Email', en: 'Email', sv: 'Email' };
export const companyPlaceholder = { de: 'Company', en: 'Company', sv: 'Företag' };
export const namePlaceholder = { de: 'Name', en: 'Name', sv: 'Namn' };
export const header = { de: 'Sign up', en: 'Sign up', sv: 'Skapa konto' };
export const loginLabel = {
  de: 'Already have an account?',
  en: 'Already have an account?',
  sv: 'Har du redan ett konto?',
};
export const successLabel = {
  de: "An email has been sent with instructions on how to complete the signup process. Didn't get the email? Remember to check the spam folder",
  en: "An email has been sent with instructions on how to complete the signup process. Didn't get the email? Remember to check the spam folder",
  sv: 'Ett email har skickats med instruktioner för att slutföra registreringen. Inget email? Kolla din skräpkorg!',
};
export const loadingLabel = { de: 'Signing up...', en: 'Signing up...', sv: 'Skapar konto...' };
export const companyLabel = {
  de: 'Sign up as a company',
  en: 'Sign up as a company',
  sv: 'Registrera dig som företag',
};
export const agreementLabel = {
  de: (
    <span>
      I accept the{' '}
      <a target="_blank" href={'/membership'} rel="noopener noreferrer">
        Future Skill Membership Agreement
      </a>
    </span>
  ),
  en: (
    <span>
      I accept the{' '}
      <a target="_blank" href={'/membership'} rel="noopener noreferrer">
        Future Skill Membership Agreement
      </a>
    </span>
  ),
  sv: (
    <span>
      Jag accepterar{' '}
      <a target="_blank" href={'/membership'} rel="noopener noreferrer">
        Future Skills Medlemsavtal
      </a>
    </span>
  ),
};
export const GDPRLabel = {
  de: (
    <span>
      I accept the{' '}
      <a href={privacyPolicyPDF} target="_blank" rel="noopener noreferrer">
        Future Skill Privacy Policy
      </a>
    </span>
  ),
  en: (
    <span>
      I accept the{' '}
      <a href={privacyPolicyPDF} target="_blank" rel="noopener noreferrer">
        Future Skill Privacy Policy
      </a>
    </span>
  ),
  sv: (
    <span>
      Jag accepterar{' '}
      <a href={privacyPolicyPDF} target="_blank" rel="noopener noreferrer">
        Future Skills Integritetspolicy
      </a>
    </span>
  ),
};
export const companyDescription = {
  de: 'Sign up to become a member of the coding community. To sign up for coding tests you need to create a company account.',
  en: 'Sign up to become a member of the coding community. To sign up for coding tests you need to create a company account.',
  sv: 'Bli medlem för att delta i kodarcommunityt. Om du vill registrera dig för kompetenstester behöver du skapa ett företagskonto.',
};
